export default __webpack_public_path__ + "e4698fd0afb2d801068ba111be7d8240.png";